export { FullBleedHero } from './FullBleedHero';
